import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Info } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    TooltipApprovalInfo,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const TableAdminLawyerManagements = ({ useFetchInit }) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    const { fetchAllManagements } = FetchData
    const { dataManagements, loadingFetchAllManagements } = fetchAllManagements

    // ------------------------------------------------ Actions
    const { 
        handleClickFetchSpecificManagement
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "gestion_fecha", headerName: "FECHA GESTION", minWidth: 160, filter: true },
        { field: "gestion_codigo", headerName: "IDENTIFICADOR", minWidth: 160, filter: true },
        { field: "tipo_gestion", headerName: "GESTIÓN", minWidth: 200, filter: true },
        { field: "process_number", headerName: "PROCESO", minWidth: 160, filter: true },
        { field: "jdo_process_number", headerName: "PROCESO (JUZGADO)", minWidth: 160, filter: true },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 250,
            maxWidth: 250,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellClass: (params) => {

                if(params.value === 'Pendiente Aprobacion') return 'bg-warning';
                if(params.value === 'Rechazado') return 'bg-danger';
                if(params.value === 'Aprobado') return 'bg-success';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data
                return (
                    <TooltipApprovalInfo
                        texto_approval={value}
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                )
            }
        },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idmanagement } = params.data

                return (
                    <CustomDropDown>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificManagement(idmanagement, 'EDITABLE')}
                        >
                            <ListItemIcon> <Info color="black"/> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllManagements)&&(<LinearLoading />)}
            <CustomTableData 
                rowConfig={dataManagements}
                columnConfig={columnConfig}
            />
        </div>
    )
}
